import { setImagePatternScaleBasesAction as setImagePatternScaleBasesOperation } from 'editor/src/store/editor/slice';

export default setImagePatternScaleBasesOperation;
